import styled from 'styled-components'
export const SiteSupersedeTitle = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  height: 48px;
  width: 100%;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
  margin-bottom: 16px;
`

export const SiteSupersedeModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const SiteSupersedeModalFooterButtonWrapper = styled.div`
  margin-left: 16px;
`

export const SiteSupersedeModalText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`
export const SitesTableWrapper = styled.div`
  .tabs-wrapper {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 16px;
  }

  .tab {
    padding: 10px 20px;
    border: 1px solid #e0e0e0;
    border-bottom: none;
    background: #ffffff;
    cursor: pointer;
    font-weight: 500;
    margin-right: 4px;
    color: rgba(32, 32, 32, 0.5);
  }

  .tab.active {
    color: #ff2d6f;
    background: #f7f7f7;
    font-weight: 600;
    color: rgba(32, 32, 32, 0.5);
  }

  td:nth-child(2) {
    background-color: rgba(32, 32, 32, 0.02);
  }

  td:nth-child(3) {
    border-left: 1px solid rgba(32, 32, 32, 0.1);
  }

  td {
    p {
      color: rgba(32, 32, 32, 0.7);
      margin-right: 8px;
    }
  }

  tr: hover {
    td:first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    td:last-child {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    td {
      border-bottom: none !important;
      border-top: 2px solid #fff !important;
    }
    cursor: pointer;
    td:last-child {
      p {
        color: #0aa1f4;
      }
      svg {
        path {
          fill: #0aa1f4;
        }
      }
    }
  }
`
